// Fonctions pour gérer les différents types de récurrences
import { RecurrenceValues } from 'src/Hooks/Forms/UseCreateEventForm/useCreateEventForm.types';
import { CreateEventDto } from 'src/Services/API/generated';
import parseIntSafe from 'src/Services/Shared/parseIntSafe';

export const handleYearlyRecurrence = (values: RecurrenceValues) => {
  const recurrence: Partial<CreateEventDto['recurrence']> = {
    byMonth: values.byMonth,
  };

  if (values.monthDaySelected) {
    if (values.byWeekDay === '') {
      recurrence.byMonthDay = [parseIntSafe(values.byMonthDay)];
    } else {
      recurrence.byWeekDay = [parseIntSafe(values.byWeekDay)];
      recurrence.bySetPos = parseIntSafe(values.byMonthDay);
    }
  }

  return recurrence;
};
